require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./svgicon"), require("./truncatedtext"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./svgicon", "./truncatedtext"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./svgicon"), require("./truncatedtext")) : factory(root["./utils"], root["./svgicon"], root["./truncatedtext"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__13__, __WEBPACK_EXTERNAL_MODULE__17__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[7],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/assertThisInitialized");

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-ui-carbon");

/***/ }),

/***/ 13:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__13__;

/***/ }),

/***/ 165:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(166);


/***/ }),

/***/ 166:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _Button = _interopRequireDefault(__webpack_require__(167));

exports["default"] = _Button["default"];
exports.Button = _Button["default"];

/***/ }),

/***/ 167:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _svgicon = __webpack_require__(13);

var _truncatedtext = _interopRequireDefault(__webpack_require__(17));

var _utils = __webpack_require__(4);

var _baUiCarbon = __webpack_require__(12);

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 *
 */
var BaPropTypes = _utils.propsUtils.BaPropTypes;

var Button = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(Button, _Component);

  function Button() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_ref", function (node) {
      _this._node = node;
    });
    return _this;
  }

  var _proto = Button.prototype;

  _proto.focus = function focus() {
    this._node.focus();
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        children = _this$props.children,
        dir = _this$props.dir,
        hasIconOnly = _this$props.hasIconOnly,
        iconDescription = _this$props.iconDescription,
        kind = _this$props.kind,
        renderIcon = _this$props.renderIcon,
        size = _this$props.size,
        style = _this$props.style,
        tabIndex = _this$props.tabIndex,
        title = _this$props.title,
        active = _this$props.active,
        button = _this$props.button,
        ellipsis = _this$props.ellipsis,
        fullWidth = _this$props.fullWidth,
        hidden = _this$props.hidden,
        hover = _this$props.hover,
        icon = _this$props.icon,
        iconLeft = _this$props.iconLeft,
        iconRight = _this$props.iconRight,
        iconSize = _this$props.iconSize,
        intent = _this$props.intent,
        label = _this$props.label,
        numShape = _this$props.numShape,
        pageNumShape = _this$props.pageNumShape,
        set = _this$props.set,
        textAlign = _this$props.textAlign,
        textDir = _this$props.textDir,
        variant = _this$props.variant,
        otherCarbonButtonProps = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["children", "dir", "hasIconOnly", "iconDescription", "kind", "renderIcon", "size", "style", "tabIndex", "title", "active", "button", "ellipsis", "fullWidth", "hidden", "hover", "icon", "iconLeft", "iconRight", "iconSize", "intent", "label", "numShape", "pageNumShape", "set", "textAlign", "textDir", "variant"]);
    var disabled = this.props.disabled; // remap children

    var mappedChildren = children != null ? children : label;

    if (mappedChildren && typeof mappedChildren === 'string') {
      var resolvedNumShape = _utils.Bidi.resolveNumShape(pageNumShape, numShape);

      var labelStr = _utils.Bidi.reshape(mappedChildren, resolvedNumShape);

      mappedChildren = labelStr;

      if (fullWidth && ellipsis !== false || ellipsis) {
        mappedChildren = /*#__PURE__*/_react["default"].createElement(_truncatedtext["default"], {
          value: labelStr,
          textDir: textDir != null ? textDir : ''
        });
      }
    } // remap dir


    var mappedDir = _utils.Bidi.resolveDir(label, dir != null ? dir : '');

    if (mappedDir === '') {
      mappedDir = undefined;
    } // remap kind


    var mappedKind = kind;

    if (mappedKind === undefined) {
      var mappedSet = set != null ? set : 'primary';

      if (variant === 'frame') {
        mappedKind = 'tertiary';
      } else if (variant === 'icon' || variant === 'inline' || variant === 'frameless') {
        mappedKind = 'ghost';
      } else if (intent === 'danger') {
        mappedKind = mappedSet === 'primary' ? 'danger--primary' : 'danger';
      } else if (variant === 'barOff') {
        mappedKind = 'ghost';
      } else if (mappedSet === 'primary') {
        mappedKind = 'primary';
      } else {
        mappedKind = 'secondary';
      }
    } // remap hasIconOnly


    var mappedHasIconOnly = hasIconOnly;

    if (hasIconOnly === undefined) {
      if (variant === 'icon' || mappedChildren === undefined) {
        mappedHasIconOnly = true;
      }
    } // remap iconDescription


    var mappedIconDescription;

    if (mappedHasIconOnly) {
      var _ref;

      mappedIconDescription = (_ref = iconDescription != null ? iconDescription : title) != null ? _ref : label;
    } // remap title


    var mappedTitle;

    if (!mappedHasIconOnly) {
      mappedTitle = title != null ? title : label;
    } // remap size


    var mappedSize = size === 'normal' ? undefined : size; // remap tabIndex

    var mappedTabIndex = disabled ? -1 : tabIndex; // remap style

    var mappedStyle = (0, _extends2["default"])({}, fullWidth ? {
      minWidth: '100%'
    } : {}, ellipsis ? {
      maxWidth: '100%'
    } : {}, hidden ? {
      visibility: 'hidden'
    } : {}, variant === 'barOff' ? {
      padding: '1px 7px 2px'
    } : {}, variant === 'inline' || variant === 'frameless' ? {
      border: '0',
      padding: '0',
      minHeight: '0'
    } : {}, style != null ? style : {});
    mappedStyle = Object.keys(mappedStyle).length ? mappedStyle : undefined;
    var mappedRenderIcon = renderIcon;

    if (!mappedRenderIcon) {
      var _ref2;

      var mappedIcon = (_ref2 = icon != null ? icon : iconRight) != null ? _ref2 : iconLeft;

      if (mappedIcon) {
        mappedRenderIcon = function mappedRenderIcon(_ref3) {
          var title = _ref3.title,
              iconProps = (0, _objectWithoutPropertiesLoose2["default"])(_ref3, ["title"]);
          return (0, _svgicon.createIcon)(mappedIcon, iconSize != null ? iconSize : 'small', null, null, iconProps);
        };
      }
    }

    return /*#__PURE__*/_react["default"].createElement(_baUiCarbon.Button, (0, _extends2["default"])({}, otherCarbonButtonProps, {
      dir: mappedDir,
      hasIconOnly: mappedHasIconOnly,
      iconDescription: mappedIconDescription,
      kind: mappedKind,
      ref: function ref(node) {
        _this2._node = node;

        _this2._ref(node);
      },
      renderIcon: mappedRenderIcon,
      size: mappedSize,
      style: mappedStyle,
      tabIndex: mappedTabIndex,
      title: mappedTitle
    }), mappedChildren);
  };

  return Button;
}(_react.Component);

exports["default"] = Button;
(0, _defineProperty2["default"])(Button, "propTypes", (0, _extends2["default"])({}, _baUiCarbon.Button.propTypes, {
  /** deprecated - is ignored and not applicable to carbon button */
  active: BaPropTypes.deprecated('deprecated - is ignored and not applicable to carbon button'),

  /** deprecated - is ignored and not applicable to carbon button */
  button: BaPropTypes.deprecated('deprecated - is ignored and not applicable to carbon button'),

  /** deprecated - use child(label) and styles */
  ellipsis: BaPropTypes.deprecated('deprecated - use child(label) and styles'),

  /** deprecated - use child(label) and styles */
  fullWidth: BaPropTypes.deprecated('deprecated - use child(label) and styles'),

  /** deprecated - set style={visibility='hidden'} */
  hidden: BaPropTypes.deprecated('deprecated - set style={visibility="hidden"}'),

  /** deprecated - is ignored and not applicable to carbon button */
  hover: BaPropTypes.deprecated('deprecated - is ignored and not applicable to carbon button'),

  /** deprecated - use renderIcon prop */
  icon: BaPropTypes.deprecated('deprecated - use renderIcon prop'),

  /** deprecated - use renderIcon prop */
  iconLeft: BaPropTypes.deprecated('deprecated - use renderIcon prop'),

  /** deprecated - use renderIcon prop */
  iconRight: BaPropTypes.deprecated('deprecated - use renderIcon prop'),

  /** depreated - Carbon button size is always 16x16 (small) */
  iconSize: BaPropTypes.deprecated('depreated - Carbon button size is always 16x16 (small)'),

  /** deprecated - use kind prop */
  intent: BaPropTypes.deprecated('deprecated - use kind prop'),

  /** deprecated - use children to pass the text on the button */
  label: BaPropTypes.deprecated('deprecated - pass the button label as its children'),

  /** deprecated - use child(label) and styles */
  numShape: BaPropTypes.deprecated('deprecated - use child(label) and styles'),

  /** deprecated - use child(label) and styles */
  pageNumShape: BaPropTypes.deprecated('deprecated - use child(label) and styles'),

  /** deprecated - use kind prop */
  set: BaPropTypes.deprecated('deprecated - use kind prop'),

  /** deprecated - Carbon button text is always left justified and vertically centered */
  textAlign: BaPropTypes.deprecated('deprecated - Carbon button text is always left justified and vertically centered'),

  /** deprecated - use child(label) and styles */
  textDir: BaPropTypes.deprecated('deprecated - use child(label) and styles'),

  /** deprecated - use kind, hasIconOnly, and styles */
  variant: BaPropTypes.deprecated('deprecated - use kind, hasIconOnly, and styles')
}));

/***/ }),

/***/ 17:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__17__;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");

/***/ })

},[[165,0]]]);
});